import { initQuestionCarsRotation } from "../animations/rotateCard";
import { Cart } from "../Classes/Cart";
import { Product } from "../Classes/Product";
import { Product365 } from "../Classes/Product365";
import { updateClickableAmountInputs } from "../forms/amountInput";
import { loadCartProductsModule } from "../modules/loadCartProductsModule";

/**
 * 
 * @param {Node} form 
 * @param {Cart} cart 
 */
export function loadExpertForm(form, cart) {

    tippy('[data-tippy-content]');
    updateClickableAmountInputs(form)
    initQuestionCarsRotation()


    let cartLoaderHTML = `
    <div class="loader-cart">
        <div class="cart-item-load"></div>
        <div class="cart-item-load"></div>
    </div>
    `;





    let expertForm = jQuery('#expert');
    let cartHolder = jQuery('.cart');

    expertForm.on("submit", (e) => {
        e.preventDefault();

        let product = new Product();
        let product365 = new Product365();

        let formSerializedData = expertForm.serializeArray()
        console.log(formSerializedData);
        let addOns = [];
        let productName, places;
        for(let entry of formSerializedData) {
            if(entry.name === 'addons[]') {
                product.addAddOn(entry.value);
            }
            if(entry.name === 'amount-places') {
                product.updatePlaces(entry.value)
            }
            if(entry.name === 'products[]') {
                product365.updateName(entry.value);
            }
        }                       

        product.updateProduct(product365);
        product.addFormAnswer("Der User hat das Experten-Formular genutzt.")

        cart.addProduct(product);
        cart.saveCartToLocalStorage(cart);
        
        let cartProductsHolder = document.getElementById("cart-products");
        cartProductsHolder.innerHTML = cartLoaderHTML;
        
        loadCartProductsModule.getCart(cart);

        expertForm.trigger("reset");


        jQuery([document.documentElement, document.body]).animate({
            scrollTop: cartHolder.offset().top
        }, 1000);
        
    })



}

